import { useSelector } from 'react-redux';
import { RootState } from 'client/_redux/reducers';

export type TSelectorFunction<TSelected> = (state: RootState) => TSelected;
export const useAppSelector = <TSelected>(fn: TSelectorFunction<TSelected>) =>
  useSelector<RootState, TSelected>(fn, objectEqual);

export const objectEqual = <TSelected>(a: TSelected, b: TSelected) =>
  JSON.stringify(a) === JSON.stringify(b);
